import type { WorkingHours } from '../types';

function formatStartDate(startDate: Date, startTime: string) {
  startDate.setHours(Number(startTime.split(':')[0]));
  startDate.setMinutes(Number(startTime.split(':')[1]));
  startDate.setSeconds(Number(startTime.split(':')[2] ? startTime.split(':')[2] : '00'));
}

function formatEndDate(endDate: Date, endTime: string) {
  endDate.setHours(Number(endTime.split(':')[0]));
  endDate.setMinutes(Number(endTime.split(':')[1]));
  endDate.setSeconds(Number(endTime.split(':')[2] ? endTime.split(':')[2] : '00'));
}
const getDayName = (date: Date): string => date.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();

const validateWorkingHours = (workingHours: WorkingHours) => {
  if (!workingHours) return false;
  if (workingHours.alwaysOpen) return true;

  if (workingHours.days && workingHours.days.length !== 0) {
    const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: workingHours.timeZone }));
    const dayName = getDayName(currentDate);
    const day = workingHours.days.find((d) => d.name === dayName);

    if (!day) return false;
    if (!day.open) return false;
    if (day.open24hours) return true;

    const startTime = day.openTime;
    const endTime = day.closeTime;

    const startDate = new Date(currentDate.getTime());
    if (!startTime) {
      console.error('Start date is undefined.');
      return false;
    }
    formatStartDate(startDate, startTime);

    const endDate = new Date(currentDate.getTime());
    if (!endTime) {
      console.error('End date is undefined.');
      return false;
    }
    formatEndDate(endDate, endTime);

    return startDate <= currentDate && endDate >= currentDate;
  }
  return false;
};

export default validateWorkingHours;
